import { BrokerUser } from '@insurance/api/requests'
import { AgentStatuses } from '@insurance/types'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'
import { DirectboxSend, Edit2, PasswordCheck, Trash } from 'iconsax-react'

import { AgentActionsTypes } from '../AgentsActions'

const iconProps = {
  size: 16
}

export const getActionColumnMenu =
  (
    onClick: (
      modal: {
        type: AgentActionsTypes
        data: BrokerUser
      } | null
    ) => void,
    t: TFunction,
    isBrokerAdmin: boolean
  ) =>
  (data: BrokerUser): MenuProps['items'] => {
    return [
      {
        label: t('edit'),
        key: 'edit',
        icon: <Edit2 {...iconProps} />,
        onClick: () => onClick({ data, type: 'edit' })
      },

      ...(isBrokerAdmin && data.status === AgentStatuses.ACTIVE
        ? [
            {
              label: t('reset_password'),
              key: 'reset-password',
              icon: <PasswordCheck {...iconProps} />,
              onClick: () => onClick({ data, type: 'resetPassword' })
            }
          ]
        : []),

      ...(isBrokerAdmin && data.status === AgentStatuses.PENDING
        ? [
            {
              label: t('re_invite'),
              key: 're-invite',
              icon: <DirectboxSend {...iconProps} />,
              onClick: () => onClick({ data, type: 'reInvite' })
            }
          ]
        : []),

      ...((data.status !== AgentStatuses.DELETED
        ? [
            {
              type: 'divider'
            },
            {
              label: t('delete'),
              key: 'delete',
              icon: <Trash {...iconProps} />,
              danger: true,
              onClick: () => onClick({ data, type: 'delete' })
            }
          ]
        : []) as Required<MenuProps>['items'])
    ]
  }
